/**
 * Czech koruna.
 */
export var CZK = {
  code: 'CZK',
  base: 10,
  exponent: 2
};